import type { InterventionTemplateSelectLabelProps } from "./intervention-template-select-label.type";

import { Space } from "antd";

import { StateTag } from "@/modules/state-tag";

export const InterventionTemplateSelectLabel = ({
  template,
}: InterventionTemplateSelectLabelProps) => (
  <Space>
    <StateTag value={template.state} type="interventionTemplate" />
    {`${template.name} v${template.version}`}
  </Space>
);
